export default __webpack_public_path__ + "static/media/fbf.678e6283.jpg";